'use client';

import BaseModal from './BaseModal';
import SignInForm from '@/components/auth/SignInForm';

const LoginModal = ({ isOpen, onClose, redirectTo = '/veo3', onSuccess }) => {
  const handleLoginSuccess = () => {
    onClose();
    if (onSuccess) onSuccess();
    if (redirectTo) {
      window.location.href = redirectTo;
    }
  };

  return (
    <BaseModal
      isOpen={isOpen}
      onClose={onClose}
      className="w-full max-w-md bg-gray-900/95 backdrop-blur-xl"
    >
      <SignInForm
        onSuccess={handleLoginSuccess}
        showBackButton={false}
        isModal={true}
        redirectTo={redirectTo}
      />
    </BaseModal>
  );
};

export default LoginModal;
